type TailorDemoAuthContext = {
  development: boolean;
  hostname: string;
  pathname: string;
  search: string;
};

function isPrivateDevelopmentHost(hostname: string): boolean {
  const normalized = hostname.toLowerCase().replace(/^\[|\]$/g, "");
  if (normalized === "localhost" || normalized === "::1" || normalized.endsWith(".local")) return true;
  if (normalized.startsWith("fc") || normalized.startsWith("fd") || normalized.startsWith("fe80:")) return true;

  const octets = normalized.split(".").map(Number);
  if (octets.length !== 4 || octets.some((octet) => !Number.isInteger(octet) || octet < 0 || octet > 255)) return false;
  const [first, second] = octets as [number, number, number, number];
  return first === 10
    || first === 127
    || (first === 172 && second >= 16 && second <= 31)
    || (first === 192 && second === 168)
    || (first === 169 && second === 254)
    // Tailscale and other CGNAT overlays use 100.64.0.0/10.
    || (first === 100 && second >= 64 && second <= 127);
}

/** Development-only anonymous entry for the self-contained Tailor recording
 * demo. Ordinary Thread routes, public hosts, and every production build keep
 * the normal authentication gate. */
export function shouldBypassAuthForTailorDemo({
  development,
  hostname,
  pathname,
  search,
}: TailorDemoAuthContext): boolean {
  if (!development || (pathname !== "/v5" && pathname !== "/v5/")) return false;
  if (new URLSearchParams(search).get("tailorDemo") !== "1") return false;
  return isPrivateDevelopmentHost(hostname);
}
